import React, { useCallback } from 'react';
import { answerTypeLabelKey, formatTranslation } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import {
  Box,
  Chip,
  IconButton,
  Switch,
  FormControlLabel,
  Stack,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useIntl } from 'react-intl';
import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import {
  ANSWER_CARD_HEADER_SX,
  DELETE_ANSWER_BUTTON_SX,
} from './styles';
import {
  getAnswerTypeChipSx,
  getRequiredLabelSx,
  getRequiredSwitchSx,
} from './answerTypeTheme';

interface AnswerCardHeaderProps {
  answerType: AnswerType;
  isRequired: boolean;
  onRequiredChange: (isRequired: boolean) => void;
  onDelete: () => void;
}

export function AnswerCardHeader({
  answerType,
  isRequired,
  onRequiredChange,
  onDelete,
}: AnswerCardHeaderProps): React.ReactElement {
  const intl = useIntl();

  const handleRequiredChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onRequiredChange(event.target.checked);
    },
    [onRequiredChange]
  );

  return (
    <Box sx={ANSWER_CARD_HEADER_SX}>
      <Chip
        label={formatTranslation(intl, answerTypeLabelKey(answerType))}
        size="small"
        sx={getAnswerTypeChipSx(answerType)}
      />
      <Stack direction="row" spacing={0.5} alignItems="center">
        <FormControlLabel
          control={
            <Switch
              checked={isRequired}
              onChange={handleRequiredChange}
              size="small"
              sx={getRequiredSwitchSx(answerType)}
            />
          }
          label={formatTranslation(intl, InspectionTranslationKeys.required)}
          labelPlacement="start"
          sx={getRequiredLabelSx(answerType)}
        />
        <IconButton onClick={onDelete} size="small" sx={DELETE_ANSWER_BUTTON_SX}>
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
}

export const MemoAnswerCardHeader = React.memo(AnswerCardHeader);
